<template>
    <font-awesome-icon v-if="icon" class="fill-current" :icon="icon" />
</template>

<script setup lang="ts">
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {computed} from 'vue';
import {getIcon} from '../../helpers/fontAwesome';
import {getPrefixByWeight, type IconName, type IconWeight} from '../../types/icon';
import {computedAsync} from '@vueuse/core';

type Props = {
    name: IconName;
    solid?: boolean;
};

const props = defineProps<Props>();

const iconWeight = computed((): IconWeight => {
    if (props.solid) return 'solid';
    return 'regular';
});

const iconPrefix = computed(() => getPrefixByWeight(iconWeight.value));
const icon = computedAsync(() => getIcon(iconPrefix.value, props.name));
</script>
